export default "__VITE_ASSET__eed57013__"